const ONBOARDING_ENABLED_PATHS = [
  '/get-started',
  '/home',
  '/board/views',
  '/board/attribution',
  '/dashboard',
  '/destinations',
  '/integrations',
  '/setup',
] as const;

export { ONBOARDING_ENABLED_PATHS };
